/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Form, Container, Button, Spinner } from 'react-bootstrap';
import { Stack } from '@mui/material';
import CheckboxInput from 'components/input/CheckboxInput';
import TextAreaInput from 'components/input/TextAreaInput';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import { useFormik } from 'formik';
import { debounce } from 'lodash';
import { useAppDispatch } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import {
  getActivitiesAndHonors,
  updateActivitiesAndHonors,
} from 'app/activitiesAndHonors/activitiesAndHonorsSlice';
import { checkEnableParseJSON } from 'components/helper/helper';
import LoadingContent from 'components/LoadingContent';
import Grid from '@mui/joy/Grid';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import { PAGE_NAME } from 'constants/common';
import pageStatusService from 'services/pageStatusService';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';

const ResponsibilitiesAndCircumstances = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const query = new URLSearchParams(useLocation().search);
  const check = query.get('check');
  // const activitiesAndHonors = useAppSelector((store) => store.activitiesAndHonors);
  let studentId = getUserId();
  let token = getAccessToken();
  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [responsibilitiesAndCircumstances, setResponsibilitiesAndCircumstances] =
    React.useState<any>({
      responsibilities: {
        assistingFamily: false,
        farmWork: false,
        interpreting: false,
        managingFinances: false,
        providingTransportation: false,
        takingCareOfSick: false,
        takingCareOfYounger: false,
        takingCareOfOwnChild: false,
        workingPaidJob: false,
        other: false,
        none: false,
      },
      otherDescription: '',
      circumstances: {
        longCommute: false,
        homelessness: false,
        unstableLiving: false,
        unstableInternet: false,
        livingIndependently: false,
        none: false,
      },
    });
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleReviewedAndComplete(PAGE_NAME.RESPONSIBILITIES_AND_CIRCUMSTANCES, reviewedAndComplete, setReviewedAndComplete);
  }
  const formik = useFormik({
    initialValues: responsibilitiesAndCircumstances,
    onSubmit: async (values) => {
      const studentId = getUserId();
      const token = getAccessToken();
      if (token && studentId) {
        const newValues = {
          responsibilities_and_circumstances: JSON.stringify({
            responsibilities: values.responsibilities,
            otherDescription: values.otherDescription,
            circumstances: values.circumstances,
          }),
          student_id: studentId,
        };
        await dispatch(updateActivitiesAndHonors(newValues));
      } else {
        handleLogout();
      }
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    history.push(routers.additionalInfo.path);
  };

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      const pageStatus: {
        student_completed: boolean;
      } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.RESPONSIBILITIES_AND_CIRCUMSTANCES);
      if(pageStatus) {
        setReviewedAndComplete(pageStatus.student_completed);
      }
      const res = await dispatch(getActivitiesAndHonors(studentId));
      const dataLoaded = res.payload;
      if (dataLoaded) {
        if (dataLoaded.responsibilities_and_circumstances) {
          const parsedData = checkEnableParseJSON(dataLoaded.responsibilities_and_circumstances);
          setResponsibilitiesAndCircumstances(parsedData);
          formik.setValues(parsedData);
        }
      }
      setLoading(false);
      formik.setStatus('idle');
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto save function
  const debounceSaving = React.useCallback(
    debounce(() => {
      formik.handleSubmit();
    }, 1500),
    []
  );

  React.useEffect(() => {
    debounceSaving();
  }, [formik.values]);


  const handleChange = (field: string, value: boolean) => {
    formik.setFieldValue(`responsibilities.${field}`, value);
  };

  const handleCircumstancesChange = (field: string, value: boolean) => {
    formik.setFieldValue(`circumstances.${field}`, value);
  };

  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { percentOnProcess: 50, title: 'Responsibilities', specialId: 'Responsibilities' },
          { percentOnProcess: 100, title: 'Circumstances Experienced', specialId: 'Circumstances_Experienced' },
          
        ]}
        title="Responsibilities and Circumstances"
        process={1}
        icon={<StackedLineChartIcon />}
        isMobile={isMobile}
      />
      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div id="Responsibilities" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                Responsibilities and Circumstances
              </span>
            </div>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12}>
                <div className={`${isMobile ? 'mb-1' : 'mb-2'}`} style={{ fontSize: isMobile ? '14px' : '1rem' }}>
                  Sometimes academics and activities are impacted by household responsibilities or
                  other circumstances. Sharing this information with colleges can help them better
                  understand the context of your application. You may repeat information you already
                  provided elsewhere in your Common App.
                </div>
              </Grid>
              <Grid xs={12}>
                <div className={`label-14px ${isMobile ? 'mb-2' : 'mb-3'}`}>
                  <div
                    style={{
                      backgroundColor:
                        check === 'true' && !Object.values(formik.values.responsibilities).some(
                          (value) => value === true
                        ) 
                          ? '#ffebee'
                          : 'transparent',
                      display: 'inline-block',
                      padding: '2px 8px',
                      borderRadius: '4px',
                    }}
                  >
                    Please select which responsibilities you spend 4 or more hours per week doing. *
                  </div>
                </div>
              </Grid>
              <Grid xs={12}>
                <Stack spacing={isMobile ? 0.5 : 1} className={`${isMobile ? 'mb-2' : 'mb-3'}`}>
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Assisting family or household members with tasks such as doctors' appointments, bank visits, or visa interviews"
                    name="assistingFamily"
                    values={formik.values.responsibilities.assistingFamily}
                    onChange={(e) => handleChange('assistingFamily', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Farm work or unpaid work for a family business"
                    name="farmWork"
                    values={formik.values.responsibilities.farmWork}
                    onChange={(e) => handleChange('farmWork', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Interpreting or translating for family or household members"
                    name="interpreting"
                    values={formik.values.responsibilities.interpreting}
                    onChange={(e) => handleChange('interpreting', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Managing family or household finances, budget, or paying bills"
                    name="managingFinances"
                    values={formik.values.responsibilities.managingFinances}
                    onChange={(e) => handleChange('managingFinances', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Providing transportation for family or household members"
                    name="providingTransportation"
                    values={formik.values.responsibilities.providingTransportation}
                    onChange={(e) => handleChange('providingTransportation', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Taking care of sick, disabled, and/or elderly members of my family or household"
                    name="takingCareOfSick"
                    values={formik.values.responsibilities.takingCareOfSick}
                    onChange={(e) => handleChange('takingCareOfSick', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Taking care of younger family or household members"
                    name="takingCareOfYounger"
                    values={formik.values.responsibilities.takingCareOfYounger}
                    onChange={(e) => handleChange('takingCareOfYounger', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Taking care of my own child or children"
                    name="takingCareOfOwnChild"
                    values={formik.values.responsibilities.takingCareOfOwnChild}
                    onChange={(e) => handleChange('takingCareOfOwnChild', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Working at a paid job to contribute to my household's income"
                    name="workingPaidJob"
                    values={formik.values.responsibilities.workingPaidJob}
                    onChange={(e) => handleChange('workingPaidJob', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Other"
                    name="other"
                    values={formik.values.responsibilities.other}
                    onChange={(e) => handleChange('other', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="None of these"
                    name="none"
                    values={formik.values.responsibilities.none}
                    onChange={(e) => handleChange('none', e.target.checked)}
                  />
                </Stack>
              </Grid>
              {formik.values.responsibilities.other && (
                <Grid xs={12}>
                  <div className="mt-3">
                    <TextAreaInput
                      disabled={reviewedAndComplete}
                      label="Please describe:"
                      name="otherDescription"
                      values={formik.values.otherDescription}
                      onChange={(e) => formik.setFieldValue('otherDescription', e.target.value)}
                      countText={150}
                      isOverCount={true}
                    />
                  </div>
                </Grid>
              )}
              <Grid xs={12}>
                <div className={`label-14px ${isMobile ? 'mt-2 mb-2' : 'mt-4 mb-3'}`}>
                  <div
                    style={{
                      backgroundColor:
                        check === 'true' && !Object.values(formik.values.circumstances).some((value) => value === true) 
                          ? '#ffebee'
                          : 'transparent',
                      display: 'inline-block',
                      padding: '2px 8px',
                      borderRadius: '4px',
                    }}
                  >
                    Please select which circumstances you've experienced.*
                  </div>
                </div>
              </Grid>
              <Grid id="Circumstances_Experienced" xs={12}>
                <Stack spacing={isMobile ? 0.5 : 1}>
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Commuting 60 minutes or more to and from school each day"
                    name="longCommute"
                    values={formik.values.circumstances.longCommute}
                    onChange={(e) => handleCircumstancesChange('longCommute', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Experiencing homelessness or another unstable living situation"
                    name="homelessness"
                    values={formik.values.circumstances.homelessness}
                    onChange={(e) => handleCircumstancesChange('homelessness', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Living without consistent heat, power, water, or access to food"
                    name="unstableLiving"
                    values={formik.values.circumstances.unstableLiving}
                    onChange={(e) => handleCircumstancesChange('unstableLiving', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Living without reliable or usable internet"
                    name="unstableInternet"
                    values={formik.values.circumstances.unstableInternet}
                    onChange={(e) => handleCircumstancesChange('unstableInternet', e.target.checked)}
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="Living independently or living on my own (not including boarding school)"
                    name="livingIndependently"
                    values={formik.values.circumstances.livingIndependently}
                    onChange={(e) =>
                      handleCircumstancesChange('livingIndependently', e.target.checked)
                    }
                  />
                  <CheckboxInput
                    disabled={reviewedAndComplete}
                    label="None of these"
                    name="none"
                    values={formik.values.circumstances.none}
                    onChange={(e) => handleCircumstancesChange('none', e.target.checked)}
                  />
                </Stack>
              </Grid>
            </Grid>

            <div className={`${isMobile ? 'my-2' : 'my-3'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between'} border-top ${isMobile ? 'pt-2' : 'pt-3'}`}>
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-start`}>
                <div className="d-flex flex-column align-items-start">
                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>
              
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {responsibilitiesAndCircumstances.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>
    </>
  );
};

export default ResponsibilitiesAndCircumstances;
